import React, { useState } from "react";
import { adminApi } from "@/lib/adminApi";

export default function AdminLogin({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await adminApi.login(email, password);
            onLogin();
        } catch (ex) {
            setErr(
                typeof ex.message === "string"
                    ? ex.message
                    : "Login fehlgeschlagen",
            );
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4">
            <form
                onSubmit={submit}
                className="w-full max-w-sm bg-white border border-zinc-200 rounded-2xl shadow-sm p-6 space-y-4"
                data-testid="admin-login-form"
            >
                <div className="text-center">
                    <div className="text-xs uppercase tracking-widest text-zinc-500">
                        SafetyAssist
                    </div>
                    <h1 className="text-2xl font-display font-bold text-zinc-900 mt-1">
                        Admin Login
                    </h1>
                </div>

                <label className="block">
                    <span className="text-sm text-zinc-600">E-Mail</span>
                    <input
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                        data-testid="admin-login-email"
                        className="mt-1 w-full px-3 py-2 border border-zinc-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                </label>
                <label className="block">
                    <span className="text-sm text-zinc-600">Passwort</span>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                        data-testid="admin-login-password"
                        className="mt-1 w-full px-3 py-2 border border-zinc-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                </label>

                {err && (
                    <div
                        className="text-sm text-red-600 bg-red-50 rounded-md px-3 py-2"
                        data-testid="admin-login-error"
                    >
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={busy}
                    data-testid="admin-login-submit"
                    className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white font-semibold py-2.5 rounded-lg"
                >
                    {busy ? "Einloggen…" : "Einloggen"}
                </button>

                <p className="text-xs text-zinc-400 text-center">
                    Nur für Administratoren.
                </p>
            </form>
        </div>
    );
}
